'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');
var _propTypes2 = _interopRequireDefault(_propTypes);
var _classnames = require('classnames');
var _classnames2 = _interopRequireDefault(_classnames);
var _Icon = require('../Icon/Icon');
var _Icon2 = _interopRequireDefault(_Icon);
require('./Avatar.css');
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

/**
 * A profile image for users.
 */
var Avatar = function Avatar(_ref) {
  var trigram = _ref.trigram,
    iconType = _ref.iconType,
    text = _ref.text,
    subText = _ref.subText,
    size = _ref.size;
  var avatarClass = (0, _classnames2.default)('c-avatar', {
    'c-avatar--small': size === 'small'
  });
  var avatarCircle = _react2.default.createElement('div', {
    className: avatarClass
  }, trigram);
  if (iconType) {
    avatarCircle = _react2.default.createElement('div', {
      className: avatarClass
    }, _react2.default.createElement(_Icon2.default, {
      type: iconType,
      noLineHeight: true
    }));
  }
  if (text) {
    return _react2.default.createElement('div', {
      className: 'c-avatar-and-text'
    }, avatarCircle, _react2.default.createElement('div', {
      className: 'c-avatar-and-text__text'
    }, _react2.default.createElement('p', null, text), subText && _react2.default.createElement('p', {
      className: 'u-text-muted'
    }, subText)));
  } else {
    return avatarCircle;
  }
};
Avatar.propTypes = process.env.NODE_ENV !== "production" ? {
  /** Trigram to display within the avatar circle */
  trigram: _propTypes2.default.string,
  /** Text to display next to the avatar */
  text: _propTypes2.default.string,
  /** Additional muted text to display below the text of the avatar */
  subText: _propTypes2.default.string,
  /** The size of the avatar */
  size: _propTypes2.default.oneOf(['small', 'normal']),
  /** The type of icon to display in front of text. */
  iconType: _propTypes2.default.string
} : {};
Avatar.defaultProps = {
  size: 'normal'
};
exports.default = Avatar;